var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCanvas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.352 8.3636C30.1844 8.3636 30.8622 7.71217 30.8622 6.90836C30.8622 6.10455 30.1844 5.45312 29.352 5.45312C28.5196 5.45312 27.8418 6.10455 27.8418 6.90836C27.8418 7.71598 28.5156 8.3636 29.352 8.3636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4299 37.25C13.0601 37.25 13.6745 37.1776 14.2651 37.0481C16.2668 36.6024 17.9831 35.4443 19.1088 33.8633C19.0731 33.8633 19.0374 33.8671 19.0018 33.8671C16.4689 33.8671 14.4157 31.89 14.4157 29.4481C14.4157 29.3986 14.4197 29.349 14.4197 29.2995H14.4157V23.8633C13.8925 23.7643 13.3495 23.7109 12.7946 23.7109C8.49394 23.7109 4.95433 26.8309 4.4668 30.8462C5.15252 34.4843 8.4543 37.25 12.4299 37.25Z",
    fill: "url(#paint0_linear_4339_28869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4299 37.25C13.0601 37.25 13.6745 37.1776 14.2651 37.0481C16.2668 36.6024 17.9831 35.4443 19.1088 33.8633C19.0731 33.8633 19.0374 33.8671 19.0018 33.8671C16.4689 33.8671 14.4157 31.89 14.4157 29.4481C14.4157 29.3986 14.4197 29.349 14.4197 29.2995H14.4157V23.8633C13.8925 23.7643 13.3495 23.7109 12.7946 23.7109C8.49394 23.7109 4.95433 26.8309 4.4668 30.8462C5.15252 34.4843 8.4543 37.25 12.4299 37.25Z",
    fill: "url(#paint1_linear_4339_28869)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9136 10.8952V10.4533H14.416V0H14.1069V1.52C14.1069 5.99238 10.6941 9.70286 6.20719 10.4533H0V10.8952H4.32838V21.2038H0V21.6457H4.32838V29.3029V29.4514C4.32838 29.9314 4.37991 30.3962 4.46711 30.8533C4.95465 26.8381 8.49425 23.7181 12.7949 23.7181C13.3498 23.7181 13.8928 23.7714 14.416 23.8705V21.8514V21.6495H19.3073V26.7086V36.899V40.0571V40.2057C19.3073 41.8552 19.8424 43.3829 20.7501 44.6438C19.9692 43.4171 19.5094 41.9771 19.5094 40.4305C19.5094 35.9657 23.267 32.3467 27.9006 32.3467C28.4119 32.3467 28.9114 32.3962 29.395 32.4838V21.6457H33.9136V21.2038H29.395V10.8952H33.9136ZM29.0858 12.2705C29.0858 16.7429 25.673 20.4533 21.1861 21.2038H14.416V10.8952H29.0858V12.2705Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4095 47.9967C28.0397 47.9967 28.6541 47.9243 29.2447 47.7948C31.2463 47.3491 32.9626 46.191 34.0883 44.61C34.0527 44.61 34.017 44.6138 33.9813 44.6138C31.4485 44.6138 29.3953 42.6367 29.3953 40.1986C29.3953 40.1491 29.3992 40.0996 29.3992 40.05H29.3953V32.591V32.4653C28.9077 32.3815 28.4123 32.3281 27.901 32.3281C23.2674 32.3281 19.5098 35.9472 19.5098 40.4119C19.5098 41.9586 19.9696 43.3986 20.7504 44.6253C22.213 46.6634 24.6467 47.9967 27.4095 47.9967Z",
    fill: "url(#paint2_linear_4339_28869)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4095 47.9967C28.0397 47.9967 28.6541 47.9243 29.2447 47.7948C31.2463 47.3491 32.9626 46.191 34.0883 44.61C34.0527 44.61 34.017 44.6138 33.9813 44.6138C31.4485 44.6138 29.3953 42.6367 29.3953 40.1986C29.3953 40.1491 29.3992 40.0996 29.3992 40.05H29.3953V32.591V32.4653C28.9077 32.3815 28.4123 32.3281 27.901 32.3281C23.2674 32.3281 19.5098 35.9472 19.5098 40.4119C19.5098 41.9586 19.9696 43.3986 20.7504 44.6253C22.213 46.6634 24.6467 47.9967 27.4095 47.9967Z",
    fill: "url(#paint3_linear_4339_28869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4339_28869",
    x1: 18.1018,
    y1: 0.679052,
    x2: 9.94194,
    y2: 44.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68BE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#461CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4339_28869",
    x1: 11.7029,
    y1: 36.5458,
    x2: 12.0047,
    y2: 20.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4339_28869",
    x1: 34.4715,
    y1: 3.70554,
    x2: 26.3116,
    y2: 47.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68BE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#461CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4339_28869",
    x1: 26.7388,
    y1: 47.3804,
    x2: 26.9223,
    y2: 31.2103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#B3B3B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCanvas);
export default __webpack_public_path__ + "static/media/logo-canvas.eda1cbda2f6e3a01af93f3c720e9a9d0.svg";
export { ForwardRef as ReactComponent };